<template>
<div>
<div v-for="(con, key) in cons" >
{{key}}
   <pre id="console" class="console text-light bg-dark" style="overflow: scroll;height: 300px;position : relative; bottom:0;"><code>
                            
        {{con}}
    </code></pre>
</div>
</div>
</template>
<script>


import Axios from "axios";
export default {
    props: ['task'],
    data: function() {
        return {

            cons: ''
        };
    },
    mounted() {
        this.callConsole();

        if(this.task.state < 8)
        setInterval(function () {
          this.callConsole();
        }.bind(this), 3000); 
    },
    methods: {
        callConsole(){

            axios.get("/task/" + this.task.id +'/console', {}).then(response => {
                
                    this.cons = response.data
                
            });

            //var container = document.querySelector('.console');
            //container.scrollTop = container.scrollHeight;
        }
    
    }
};
</script>
